import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppKandidaat from './AppKandidaat';
import AppBedrijven from './AppBedrijven';
import AppWeRepresent from './AppWeRepresent';
import { SITE } from './domainConfig';
import { I18nProvider } from './i18n';

// Selecteer de juiste App op basis van REACT_APP_SITE env variabele
const APPS = {
  kandidaat: AppKandidaat,
  bedrijven: AppBedrijven,
  werepresent: AppWeRepresent,
  all: App, // Lokale development: alle routes in één app
};

const SelectedApp = APPS[SITE] || App;

function getInitialLanguageFromUrl() {
  if (typeof window === 'undefined') return undefined;
  const params = new URLSearchParams(window.location.search);
  return params.get('lang') || undefined;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider initialLanguage={getInitialLanguageFromUrl()}>
      <SelectedApp />
    </I18nProvider>
  </React.StrictMode>
);